import React, { useContext } from 'react';
import styled from 'styled-components';
import { LocaleContext } from '@repo/contexts/LocaleContext';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

import USAIcon from '../svgs/usa-icon.svg';
import CanadaIcon from '../svgs/canada-icon.svg';
import sharedStyles from '../styles';

const Button = styled.button`
  background: none;
  cursor: pointer;
  border: 1px solid transparent;
  margin-left: ${sharedStyles.spacing['spacing-sm']};
  z-index: 1;
  padding-block: 1px;
  padding-inline: 6px;

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.border};
  }
`;

function CountryPicker() {
  const localeContext = useContext(LocaleContext);
  const currency = localeContext?.currency;

  const { tt } = useUiComponentsInternationalContext();

  const getCountryFlag = () => {
    if (currency === 'CAD') {
      return <CanadaIcon height="100%" width={28.3} />;
    }

    return <USAIcon height="100%" width={28.3} />;
  };

  return (
    currency && (
      <Button
        type="button"
        aria-label={tt(s => s.notificationBannerCommon.countryPickerAriaLabel)}
        onClick={event => {
          event.preventDefault();
          localeContext.setCountryPickerActive(
            !localeContext.countryPickerActive
          );
        }}
      >
        {getCountryFlag()}
      </Button>
    )
  );
}

export default CountryPicker;
